import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 20 2",
  "content": "<symbol viewBox=\"0 0 20 2\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-minus\">\r\n<rect width=\"20\" height=\"2\" fill=\"\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol